import React from "react";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import { BottomUnderlineView } from "../bottomUnderlineView/BottomUnderlineView";
import {
  PLAYER_PLACEHOLDER_HEIGHT,
  PLAYER_PLACEHOLDER_WIDTH,
} from "../../utils/data";
import { SelectedPlayerCard } from "../selectedPlayerCard/SelectedPlayerCard";
import { useSelectCircleStore } from "../../stores/StoreContext";
import { observer } from "mobx-react-lite";
import { useCourtBooking } from "../../context/courtBookingContext";
import { Player } from "../../apis/types";

interface Props {
  onRemoveIconClick?: (player: Player) => void;
}

export const SelectedPlayersList: React.FC<Props> = observer(
  ({ onRemoveIconClick }) => {
    const selectCircleStore = useSelectCircleStore();
    const selectedPlayers = selectCircleStore.selectedPlayers;
    const { userModel } = useCourtBooking();

    return (
      <div
        style={{
          ...styles.container,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: 20,
        }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}>
          <div>
            <BottomUnderlineView
              borderRadius={20}
              borderWidth={0}
              borderColor={Colors.gold}
              width={PLAYER_PLACEHOLDER_WIDTH}
              height={PLAYER_PLACEHOLDER_HEIGHT}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "stretch",
                  justifyContent: "center",
                  gap: 5,
                  height: "100%",
                }}>
                <SelectedPlayerCard
                  key={userModel?.userId}
                  imageUrl={userModel?.userImageUrl}
                  name={userModel?.name ?? ""}
                  rating={userModel?.userRating?.toString()}
                  style={{
                    flex: 1,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                />
              </div>
            </BottomUnderlineView>
            <TCText
              value={`Secured player${selectedPlayers.length !== 1 ? "s" : ""}`}
              style={{ ...styles.title, color: Colors.green }}
            />
          </div>
          {selectedPlayers.length ? (
            <div
              style={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}>
              <BottomUnderlineView
                borderRadius={20}
                borderWidth={2}
                borderColor={Colors.gold}
                width={PLAYER_PLACEHOLDER_WIDTH * selectedPlayers.length}
                height={PLAYER_PLACEHOLDER_HEIGHT}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "stretch",
                    justifyContent: "center",
                    gap: 5,
                    height: "100%",
                  }}>
                  {selectedPlayers.map((player) => (
                    <SelectedPlayerCard
                      key={player.userId}
                      imageUrl={player.userImageUrl}
                      name={player.name}
                      rating={player.userRating?.toString()}
                      onRemoveIconClick={
                        onRemoveIconClick
                          ? () => onRemoveIconClick(player)
                          : undefined
                      }
                      style={{
                        flex: 1,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    />
                  ))}
                </div>
              </BottomUnderlineView>
              <TCText
                value={`Secured player${
                  selectedPlayers.length !== 1 ? "s" : ""
                }`}
                style={styles.title}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
);

const styles = {
  container: {
    marginLeft: 5,
  },
  playersContainer: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    justifyContent: "center",
    gap: 5,
  },
  title: {
    fontWeight: 500,
    fontSize: 8,
    color: "white",
    marginTop: 2,
  },
};
